export default __webpack_public_path__ + "static/media/coin-into-piggy-bank.bf7403a4.svg";